module.exports = __webpack_public_path__ + "static/media/90900-InoxCompleto.44613646.png";